
import React, { useState } from 'react';
import { Button } from '../../../components/base/Button';

export const NewsletterSection: React.FC = () => {
  const [email, setEmail] = useState('');
  const [isSubmitted, setIsSubmitted] = useState(false);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (email) {
      setIsSubmitted(true);
      setEmail('');
      setTimeout(() => setIsSubmitted(false), 3000);
    }
  };

  return (
    <section className="py-16 bg-gray-50">
      <div className="max-w-4xl mx-auto px-6 text-center">
        <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
          WhatsApp for Cruise Live Updates +91 7899350100
        </h2>
        <p className="text-lg text-gray-700 mb-8">
          Join our email list and get access to special deals exclusive to our subscribers.
        </p>
        
        <form onSubmit={handleSubmit} className="max-w-md mx-auto">
          <div className="flex flex-col sm:flex-row gap-4">
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Enter your email here"
              className="flex-1 px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-emerald-500 focus:border-emerald-500 outline-none"
              required
            />
            <Button type="submit" className="whitespace-nowrap px-6 py-3">
              Sign Up
            </Button>
          </div>
          {isSubmitted && (
            <p className="mt-4 text-emerald-600 font-medium">
              Thanks for submitting!
            </p>
          )}
        </form>
      </div>
    </section>
  );
};
